// extracted by mini-css-extract-plugin
export default {"selectHolder":"SelectToken_selectHolder__pyJBD","selectToken":"SelectToken_selectToken__tqCWV","arrow":"SelectToken_arrow__5XXKU","inputLabel":"SelectToken_inputLabel__qxFhF"};